import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { mount, parseSlexSource } from "../../../engine/index";

var root = $.from_html(`<div class="slex-streamdown-error" role="alert"><div class="slex-streamdown-error-title">Failed to render SlexKit</div> <div class="slex-streamdown-error-message"> </div></div>`);
var root_1 = $.from_html(`<div></div>`);
var root_2 = $.from_html(`<pre><code> </code></pre>`);

export default function PlaygroundSlexCode($$anchor, $$props) {
	$.push($$props, true);

	let lang = $.prop($$props, 'lang', 3, ""),
		text = $.prop($$props, 'text', 3, "");

	let error = $.state(null);
	const language = $.derived(() => String(lang() ?? "").trim().split(/\s+/, 1)[0].toLowerCase());
	const isSlexKit = $.derived(() => $.get(language) === "slex");
	const runtimeInput = $.derived(() => scopedSlexKitInput(text(), $$props.domain));

	function renderPreview(node) {
		let cleanup;

		const render = () => {
			cleanup?.();
			node.replaceChildren();
			$.set(error, null);

			if (!$.get(isSlexKit)) return;

			try {
				cleanup = mount($.get(runtimeInput), node);
			} catch(err) {
				$.set(error, err, true);
			}
		};

		render();

		return {
			update: render,
			destroy() {
				cleanup?.();
				node.replaceChildren();
			}
		};
	}

	function scopedSlexKitInput(code, scope) {
		if (!scope) return code;

		const parsed = parseSlexSource(code);

		if (!parsed.ok || !parsed.value || typeof parsed.value !== "object") {
			return code;
		}

		const source = parsed.value;

		if (!("namespace" in source) && !("g" in source) && !("layout" in source) && Object.keys(source).some((key) => key.includes(":"))) {
			const { slex, ...layout } = source;

			return {
				...typeof slex === "string" ? { slex } : {},
				namespace: `${scope}::default`,
				layout
			};
		}

		return {
			...source,
			namespace: `${scope}::${String(source.namespace || "default")}`
		};
	}

	var fragment = $.comment();
	var node_1 = $.first_child(fragment);

	{
		var consequent_1 = ($$anchor) => {
			var fragment_1 = $.comment();
			var node_2 = $.first_child(fragment_1);

			{
				var consequent = ($$anchor) => {
					var div = root();
					var div_1 = $.sibling($.child(div), 2);
					var text_1 = $.child(div_1, true);

					$.reset(div_1);
					$.reset(div);

					$.template_effect(($0) => $.set_text(text_1, $0), [
						() => $.get(error) instanceof Error ? $.get(error).message : String($.get(error))
					]);

					$.append($$anchor, div);
				};

				var alternate = ($$anchor) => {
					var div_2 = root_1();

					$.action(div_2, ($$node, $$action_arg) => renderPreview?.($$node, $$action_arg), () => $.get(runtimeInput));
					$.append($$anchor, div_2);
				};

				$.if(node_2, ($$render) => {
					if ($.get(error)) $$render(consequent); else $$render(alternate, -1);
				});
			}

			$.append($$anchor, fragment_1);
		};

		var alternate_1 = ($$anchor) => {
			var pre = root_2();
			var code_1 = $.child(pre);
			var text_2 = $.child(code_1, true);

			$.reset(code_1);
			$.reset(pre);

			$.template_effect(() => {
				$.set_class(pre, 1, $.clsx(lang()));
				$.set_text(text_2, text());
			});

			$.append($$anchor, pre);
		};

		$.if(node_1, ($$render) => {
			if ($.get(isSlexKit)) $$render(consequent_1); else $$render(alternate_1, -1);
		});
	}

	$.append($$anchor, fragment);
	$.pop();
}